module.exports = __webpack_public_path__ + "img/empreendimento-logo-29.6ff159e3.png";